export default {
  mounted(el, binding) {
    processElement(el, binding.value);
  },
  updated(el, binding) {
    processElement(el, binding.value);
  }
};

function processElement(element, isDisabled) {
  if (element.nodeType !== Node.ELEMENT_NODE) return;

  if (element.__initialDisabled__ === undefined) {
    element.__initialDisabled__ = element.disabled;
  }

  if (isInteractiveElement(element)) {
    element.disabled = isDisabled || element.__initialDisabled__;
  }

  if (element.__vue__) {
    setComponentDisabled(element.__vue__, isDisabled);
  }

  Array.from(element.children).forEach((child) =>
    processElement(child, isDisabled)
  );
}

function isInteractiveElement(element) {
  const interactiveTags = ["INPUT", "SELECT", "TEXTAREA", "BUTTON", "A"];
  return interactiveTags.includes(element.tagName);
}

function setComponentDisabled(component, isDisabled) {
  if (component.__initialDisabled__ === undefined) {
    component.__initialDisabled__ = component.$props.disabled || false;
  }

  const newDisabledState = isDisabled || component.__initialDisabled__;
  component.$emit("update:disabled", newDisabledState);

  if (component.$children && component.$children.length > 0) {
    component.$children.forEach((childComponent) =>
      setComponentDisabled(childComponent, isDisabled)
    );
  }
}
